// eslint-disable-next-line import/no-cycle
import AuthService from "../../service";

const network = {
  getNetwork(page,search,sort_order) {
    return AuthService.get(`/about/network?page=${page}&search=${search}&sort_order=${sort_order}`);
  },
  showNetwork(id) {
    return AuthService.get(`/about/network/${id}`);
  },
  createNetwork(data) {
    return AuthService.post("/about/network", data);
  },
  updateNetwork(id, data) {
    return AuthService.put(`/about/network/${id}`, data);
  },
  deleteNetwork(id) {
    return AuthService.delete(`/about/network/${id}`);
  }
};
export default network;
